import { WarningSign } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Separator, Text, View, XStack } from "tamagui";

import {
  AddParticipantsDialog,
  ParticipantsTable,
} from "~/components/feature/research";

const Participants = () => {
  const { t } = useTranslation("research");
  return (
    <View paddingTop={"$4"} gap={"$2.3"}>
      <View
        minHeight={80}
        justifyContent={"space-between"}
        flexDirection="row"
        alignItems="center"
      >
        <Text
          fontFamily={"$subtitle"}
          fontWeight={"$6"}
          fontSize={"$7"}
          lineHeight={"$7"}
          color={"$gray-950"}
        >
          {t("participants-page.title")}
        </Text>
        <XStack>
          <XStack alignItems="center" gap={"$1"}>
            <WarningSign color="#F9709A" />
            <Separator
              vertical
              borderRightColor={"$pinkmain-500"}
              borderRightWidth={"$0.2"}
              height={"$5"}
            />
            <Text
              fontFamily={"$body"}
              fontWeight={"$5"}
              fontSize={"$3"}
              lineHeight={"$3"}
              color={"$gray-primary-900"}
              maxWidth={400}
            >
              Ви не зможете змінити склад списку учасників після завершення
              першого етапу дослідження
            </Text>
          </XStack>
          <AddParticipantsDialog />
        </XStack>
      </View>
      <ParticipantsTable />
    </View>
  );
};

export default Participants;
